export default __webpack_public_path__ + "static/media/icon-check.bab3acea.svg";